module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }